<template>
  <modal-layout :is-open="isOpen" class="Modal__accordion" @close="modalClose">
    <div class="Modal_area _back-cl05">
      <div class="Modal__cross-box _cross" @click="modalClose">
        <span class="Modal__cross" />
      </div>
      <div class="Modal_title">
        <span class="Modal_title_date">クラスで選ぶ</span>
      </div>
      <div class="Modal_inner modal__container">
        <ul class="Search_class_list">
          <li
            v-for="program in listPrograms"
            v-show="program.display_status == 1"
            :key="program.id"
            class="Search_class_list_box"
            style="text-transform:capitalize;"
          >
            <a
              class="Search_class_list_link"
              :style="`background-image: url(${encodeURI(decodeURI(program.icon_url))})`"
              @click="searchCategory(program.id, program.name)"
            >
              {{ program.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout'
import programcategoryService from '@/services/programcategoryService'
export default {
  name: 'MelonTVScheduleModal1',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listPrograms: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    modalClose() {
      this.$emit('close')
    },
    async init() {
      await this.getListPrograms()
    },
    async getListPrograms() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await programcategoryService.index()
      this.listPrograms = response.data
      this.$store.dispatch('loading/updateLoading', false)
    },
    searchCategory(categoryId, categoryName) {
      this.$emit('searchMelonTv', { searchCategory: categoryId, name: categoryName })
      this.$emit('close')
    }
  }
}
</script>
